import React from 'react';
import { Box, Breadcrumbs, Chip, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useIsMobile } from '../../../hooks/useResponsive';
import LocationTypeIcon from './shared/LocationTypeIcon';

/**
 * Breadcrumb bar showing the path to the currently selected location
 * Visible in ALL view modes when a location is selected
 * Responsive: fewer items and smaller chips on mobile
 */
const LocationBreadcrumbBar = ({ breadcrumbPath, onNavigate }) => {
  const isMobile = useIsMobile();

  if (!breadcrumbPath || breadcrumbPath.length === 0) return null;

  return (
    <Box sx={{
      px: { xs: 1, sm: 2 },
      py: { xs: 0.5, sm: 1 },
      bgcolor: 'action.hover',
      borderBottom: 1,
      borderColor: 'divider',
      overflowX: 'auto',
      // Hide scrollbar but allow scroll
      '&::-webkit-scrollbar': { display: 'none' },
      scrollbarWidth: 'none'
    }}>
      <Breadcrumbs
        separator={<NavigateNextIcon sx={{ fontSize: isMobile ? 16 : 20 }} />}
        maxItems={isMobile ? 3 : 6}
        itemsBeforeCollapse={1}
        itemsAfterCollapse={isMobile ? 1 : 2}
        aria-label="Location path"
      >
        {breadcrumbPath.map((crumb, idx) => {
          const isLast = idx === breadcrumbPath.length - 1;

          if (isLast) {
            return (
              <Chip
                key={crumb.id}
                icon={<LocationTypeIcon typeId={crumb.typeId} size={isMobile ? 14 : 16} />}
                label={crumb.name}
                size="small"
                color="primary"
                variant="filled"
                sx={isMobile ? { height: 24, '& .MuiChip-label': { fontSize: '0.75rem', px: 0.75 } } : {}}
              />
            );
          }

          return (
            <Chip
              key={crumb.id}
              icon={<LocationTypeIcon typeId={crumb.typeId} size={isMobile ? 12 : 14} />}
              label={crumb.name}
              size="small"
              variant="outlined"
              onClick={() => onNavigate(crumb.id)}
              clickable
              sx={isMobile ? { height: 22, '& .MuiChip-label': { fontSize: '0.7rem', px: 0.5 } } : {}}
            />
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default LocationBreadcrumbBar;
